import { render, staticRenderFns } from "./JournalTransactions.vue?vue&type=template&id=7abd2a48&"
import script from "./JournalTransactions.vue?vue&type=script&lang=ts&"
export * from "./JournalTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7abd2a48')) {
      api.createRecord('7abd2a48', component.options)
    } else {
      api.reload('7abd2a48', component.options)
    }
    module.hot.accept("./JournalTransactions.vue?vue&type=template&id=7abd2a48&", function () {
      api.rerender('7abd2a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/reports/JournalTransactions.vue"
export default component.exports